module.exports={
    // 登录页
    sjhm: 'Mobile number',
    qsrdxyzm:'Pls fill in verification code',
    fsyzm:'Send verification code',
    login:'Log in',
    yIDhmmdl:'ID and password login',
    qsrID:'Pls fill in ID',
    qsrmm:'Pls fill in password',
    ysjhmdl:'Mobile number login',
	xzsq	:'Please select a community',
	zhmmcw	:'Account or password error',
    注册管理员:'Register administrator',
    公司名:'Company name',
    //新添加的
    zc:'register',
    zhmm:'Retrieve password',
    qsrsjhm:'Pls fill in mobile phone number',
    mhzxhq:'Retrieve in seconds',
    hqyzmsb:'Failed to get verification code!',
    sbbczhmqx:'The device does not exist or does not have permission!',
    ryzc:'Personnel registration',
    sfz:'ID',
    hz:'Passport',
    jzz:'Residence permit',
    jsz:'driver license',
    nbool:'male',
    ngril:'female',
    qxkmmm:'Pls fill in the door opening password!',
    qxgh:'Plsfill in the job number!',
    scgg:'Upload succeeded',
    scsb:'Upload failed',
    xlh:'Serial number',
    wsh:'Not approved',
    ysh:'Reviewed',
    rq:'Date',
    cd:'Late',
    jb:'wWork',
    zat:'Leave early',
    qtxbt:'PlS fill in the title',
    qtxnr:'PlS fill in the content',
    ysdfkgx:'We have received your feedback. Thank you for your valuable comments!',
    fksb:'Feedback failed!',
    lya:'Open Bluetooth',
    ss:'Search',
    lykm:'Bluetooth door',
    cx:'Query',
    yc:'Once',
    lc:'Twice',
    zx:'on',
    lx:'off',
    kmen:'Open',
    // 首页
    yckm:'Remote open door',
    fkyy:'Visitor appointment',
    fxys:'Share E-key',
    ewmkm:'QR code open door',
    smkm:'Scan to open',
    yjkm:'One touch key',
    sy:'Home',
    zzzc:'Register',
    sb:'Device',
    wd:'Me',
	cw:'Error',
    // 远程开门页面
    sbmhzwz:'Device name or location',
    cxwz:'Query location',
    sbwz:'Device location',
    zt:'Status',
    km:'Open',
    kmcg:'Open the door success',
    kmsb:'Open the door failed',
    // 访客预约页面
    xm:'Name',
    rlzp:'Face image',
    tj:'Add',
    zjlx:'ID type',
    zjh:'ID number',
    xb:'Gender',
    sfcs:'City',
    sxrs:'Entourage',
    syo:'Reasons',
    fwyxq:'Visit validity',
    bfrhm:'Interviewee number',
    bfrxm:'Interviewee name',
    tjyy:'Submit appointment',
    // 分享钥匙页面
    sssb:'Search device',
    xzsb:'Select device',
    wsb:'No device',
    fwcs:'Visit times',
    bxcs:"unlimit times",
    qjzewmdzjt:'Pls aim this QR code at the device lens and scan to open the door',
    fxewm:'Generate share QR code',
	fxmm:'Share Password',
    // 自主注册页面
    jg:'Native place',
    hj:'Registered residence',
    qybm:'Company Dept',
    kh:'Card Number',
    kmmm:'Password',
    gh:'Work number',
    qd:'Confrim',
    qtxsjhm:'Pls fill in mobile number',
    qtxxm:'Pls fill in name',
    qxzbm:'Pls select Dept',
    qszkmmm:'Pls set door password',
    qtxgh:'Pls fill work number',
    zccg:'Registered successfully ',
    zcsb:'registered failed',
    // 我的页面
    txjl:'Access record',
    fkjl:'Visitor record',
    kqrb:'Daily Attendance',
    fkwm:'Feedback to us',
    tcdl:'Exit',
    // 通行记录页面
    txsj:'Access time',
    kmlx:'Open door type',
    // f访客记录页面
    lfsj:'Visit time',
    shzt:'Audit status',
    mygd:'No more',
    // 反馈我们页面
    bt:'Title',
    qsrbt:'Pls fill in title',
    ly:'Leave a message ',
    qsrly:'Pls fill in message',
    tjfk:'Sumbit feedback info',
    zhxx:'Account information',
    // 退出登录页面
    sfqdtc:'Are you sure to exit?',
    qx:'Cancel',
	// 设备搜索页面
	sbss:'Device search',
	kysb:'Available devices',
	ssjg:'Search result',
	sbtj:'Device addition',
	sblx:'Device Type',
	sfwzcj:'Keygen or not',
	qxz:'Please select',
	azwz:'Installation position',
	kmzt:'State of the door',
	wifimm:'WiFi password',
	
	// 设备设置页面
	wlgl:'Network Management',
	yggl:'Staff Management',
	qxfp:'Permission Assignment',
	gxqx:'Update Permissions',
	cqsb:'Reboot Device',
	cshsb:'Initialize Device',
	scsb:'Delete Device',
	cshPopTips:'The current operation will delete all user permissions and then download all user permissions.',
	qjscz:'Please operate with caution!',
	qrgxqxm:'Are you sure to update permissions?',
	qrcqsbm:'Are you sure to restart the device?',
	dqczjscsb:'The current operation will delete the device.',
	shgl:'Audits Management',
	bmgl:'Department',
	rygl:'Personnel Management',
	ts:'Tip',
	sbsccg:'Device deleted successfully',
	sbbcz:'Device does not exist',
	sbyc:'The device is abnormal. Please check if the device is online',
	mqxhzhmmcw:'No permission or incorrect account password',
	gxqxsb:'Failed to update permissions, error code',
	gxqxcg:'Successfully updated permissions',
	sfyzgq:'The authentication has expired. Please log in again and try again',
	qsryhmm:'Please enter the user password',
	qcsbcg:'Successfully cleared device',
	mmcw:'Password error',
	sbbzxhyc:'Device not online or abnormal',
	// 网络管理页面
	czsb:'Find devices',
	wifisz:'WIFI Settings',
	qsrSSID:'Please enter SSID',
	ytwsz:'Ethernet Settings',
	DHCPms:'DHCP Mode',
	IPdz:'IP Address',
	zwym:'Mask',
	wg:'Gateway',
	qsrIP:'Please enter IP',
	qsrMASK:'Please enter MASK',
	qsrGATEWAY:'Please enter GATEWAY',
	sgsz:'4G settings',
	tjxg:'Submit modifications',
	qxljsb:'Please connect the device first',
	qxzms:'Please select a mode',
	bnwk:'Cannot be empty',
	wificsszcg:'Successfully set WiFi parameters',
	mmszsb:'Password setting failed',
	szwlmssb:'Failed to set network mode',
	ipdzbnwk:'IP Address cannot be empty',
	ytwcsszcg:'Ethernet parameters set successfully',
	ytwcsszsb:'Ethernet parameter setting failed',
	kqcg:'Successfully opened',
	gbcg:'Successfully closed',
	kqsb:'Opening failed',
	opentips:'Open failed! If open fails multiple times, please reconnect the device and try again',
	sbtjcgzzszwifics:'Device added successfully, setting WIFI parameters',
	sbtjcg:'Device added successfully',
	zzcxpzwifi:'Reconfiguring WIFI',
	sbycz:'Device already exists',
	tjsbsb:'Adding device failed',
	wifiszsbcwm:'WIFI setting failed with error code',
	// 部门管理
	gm:'Rename',
	sc:'delete',
	xgcg:'Successfully modified',
	bmbcz:'Department does not exist',
	myqxhzhcw:'No permission or account error',
	sbhryygl:'The device or person is already associated, please clear the association first',
	tjcg:'Added successfully',
	yczgwj:'The file already exists',
	gjdbnbcz:'This node cannot be operated on',
	bmsc:'Department deletion',
	xgmc:'Modify Name',
	tjdbmmc:'Added department name',
	tjzbm:'Add Sub Department',
	// 人员管理页面
	bm:'Department',
	wsp:'Unapproved',
	rlwzc:'Face not registered',
	rlbfmzc:'Facial registration',
	rlzcsb:'Face registration failed',
	xg:'Modify',
	sccg:'Successfully deleted',
	tpgxsb:'Image update failed',
	rybcz:'Personnel do not exist',
	// 人员添加页面
	tjry:'Add people',
	yhxm:'User Name',
	qsryhxm:'Please enter the user name',
	zjhm:'ID NO',
	bmxz:'Department selection',
	yxkssj:'Effective start time',
	xzrq:'Select Date',
	yxjssj:'Effective End Time',
	sztx:'Set avatar',
	bc:'Save',
	qxzxb:'Please select gender',
	qsrzjh:'Please enter your ID number',
	qsrkh:'Please enter the card number',
	qsrgh:'Please enter the job number',
	qsrkmmm:'Please enter the door opening password',
	qsryxkssj:'Please enter a valid start time',
	qsryxjssj:'Please enter a valid end time',
	ryycz:'Person already exists',
	khycz:'Card number already exists',
	zcsbbcz:'Registered device does not exist',
	ghycz:'Job number already exists',
	// 人员修改
	xgryzl:'Modify personnel information',
	khbcz:'Card number does not exist',
	sbcwm:'Failed! Error code',
	ryxxhqsb:'Failed to obtain personnel information',
	// 权限分配
	sqzt:'Authorization status',
	wx:'Invalid',
	yx:'Valid',
	tbzt:'Synchronization status',
	wtb:'Not synchronized',
	rlwtb:'Face not synchronized',
	kwtb:'Card not synchronized',
	sbmmwtb:'Device password not synchronized',
	tb:'Synchronous',
	xz:'Select',
	qxqx:'Select All',
	sq:'Empower',
	qxzsb:'Please select a device',
	qr:'Confirm',
	qxzsqsb:'Please select an authorized device',
	bftbsb:'Partial synchronization failed',
	qcktbzt:'Please check the synchronization status',
	tbsbqcs:'Synchronization failed. Please review again and try again',
	bfscsb:'Partial deletion failed',
	scsbqcs:'Deletion failed. Please review again and try again',
	tjmk:'Add Door Card',
	rysc:'Personnel deletion',
	删除成功:'Successfully deleted',
    授权成功:'Successfully authorized',
	cg:'success',

    //再次新加
	sygx1:'Feel free to check 1',
	qrmm:'Confirm Password',
	zhmmyx:'Retrieve password email',
	yxyzm:'Email verification code',
	hqyxyzm:'Obtain email verification code',
	zzhmm:'Retrieve password',
	dt:'Read Head',
	mj:'Access control',
	jin:'In',
	chu:'Out',
	yes:'Yes',
	no:'Not',
	ysdyy:'No more',
	mygd:'No more',
	syy:'Last',
	xyy:'Next',
	rmcs:'Popular Cities',
	xzgjhdq:'Select a country or region',
    zhhyzmcw:'Account or verification code error',
    zhhmmcw:'Wrong account or password',
    xyhzc:'New user registration',
    yhm:'Name',
    qymc:'Enterprise name',
    yx:'Mailbox',
    qsryx:'Pls enter email',
	yzms:'The verification code is',
    qsryxyzm:'Pls enter email code',
    yxyzm:'The email code is incorrect!',
    yzmbzq:'Incorrect code',
    qsryhm:'enter one user name',
    hqyzmcg:'Successfully obtained code!',
    yhycz:'User already exists',
    mm:'Password',
    xmm:'New password',
    xgmm:'Change Password',
    jmm:'Old password',
    bf:'Visit',
    qt:'Negotiate',

    yycg:'Appointment succeeded',
    yysb:'Appointment failed',
    bfrbcz:'Interviewee does not exist',
    fkmhsjhmycz:'Visitor name or mobile number already exists',
    mqtczsb:'Mqtt operation failed',
    ljfghy:'Share with friends now',
    fzlj:' Copy link',
    bnzydqsj:'Cannot be earlier than the current time',
    yxqbn:'The validity period cannot be greater than 7 days',
    rqxz:'Date',
    szcg:'Set successfully',
    szsb:'Setting failed',
    yhbcz:'user does not exist',

    khkm:'Card number open',
    mmkm:'Password open door',
    zwkm:'Fingerprint open door',
    rlkm:'Face open door',

    // 手机号国家区
    zgdl:'Chinese Mainland',
    zgxg:'Hong Kong, China',
    zgam:'Macao China',
    zgtw:'Taiwan, China',
    afh:"Afghanistan",
    ade:'Andorra',
    agt:'Argentina',
    ymny:'Armenia',
    alb:'Aruba',
    adl:"Austria",
    asbj:'Azerbaijan',

    bhm:'Bahamas',
    bl:'Bahrain',
    bbds:'Barbados',
    bels:'Belarus',
    bjst:'Pakistan',
	bx:'Brazil',
    bls:'Belgium',
    cxx:'Korea',
    cdjny:'Equatorial Guinea',
    dg:'Germany',
    dm:'Denmark',
    jbt:'Djibouti',
    dmnjghg:'Dominican republic',
    els:'Russia',
    egde:'Ecuador',
    aj:'Egypt',
    aseby:'Ethiopia',

    fg:'France',
    fl:'Finland',
    flb:'Philippines',
    fdg:'Vatican',

    gby:'Gambia',
    ggghg:'Republic of the Congo',
    glby:'Columbia',
    gb:'Cuba',
    hg:'the republic of korea',
    hl:'Netherlands',
    hd:'Haiti',

    jbz:'Cambodia',
    jlbs:'Kiribati',
    jny:'Guinea',
    jbbw:"Zimbabwe",
    kml:'Cameroon',
    kmqt:'Cayman Islands',
    kny:'Kenya',
    kwt:'Kuwait',
    kldy:'Croatia',
    lys:'Laos',
    lby:'Libya',
    lwd:'Rwanda',
    mg:'U.S.A',
    mlxy:'Malaysia',
    mxg:'Mexico',
    nf:'South Africa',
    nbe:'Nepal',
    nrly:'Nigeria',
    nw:'Norway',
    plqd:'Palau Islands',
    pty:'Portugal',
    rb:'Japan',
    rd:'Sweden',
    rs:'Switzerland',
    stalb:'Saudi Arabia',
    sd:'Sudan',
    slxy:'Saint Lucia',
    tgs:'Thailand',
    tjs:'Tonga',
    teq:'turkey',
    wnrl:'Venezuela',
    wl:'Brunei',
    wkl:'Ukraine',
    xxl:'New Zealand',
    xjb:'Singapore',
    xby:'Spain',
    xl:'Greece',
    xyl:'Hungary',
    ydl:'Italy',
    yg:'britain',
    ydnxy:'Indonesia',
    yd:'India',
    yn:'Vietnam',
    ylk:'Iraq',
    zl:'Chile',
    zfghg:'Central African Republic',



    wz:'Seat',
    lym:'Blue name',
    kmcg:'Open the door successfully',
    kmsb:'Door opening failure',
    qxdkly:'Ple turn on Bluetooth first',
    手机号码在同一个公司已存在:'Phone number already exists in the same company',
    有效期要大于当前时间:'Expiration time must be greater than the current time',
    请选择部门:'Please select a department',
    生成成功:'Successfully generated',
    长按二维码下载:'Press and hold the QR code to download',
    摄像头权限被拒绝:'Camera permission denied',
    请先打开摄像头:'Please open the camera first',
    请在浏览器设置中开启摄像头权限:'Please enable camera permission in the browser settings and try again',
    知道了:'I know',
    加载中:'Loading...',
    应用不支持蓝牙功能:'The Telegram app does not support Bluetooth functionality. In order to use Bluetooth normally, the Bluetooth function will be turned on in the Google Chrome browser',
    // 浏览器中打开蓝牙功能:'Please enable Bluetooth in the browser settings.',
    复制链接:'Copy link',
    中打开:'Google Chrome Open in the browser',
    暂无部门:'No department',
    链接已复制:'Link copied',
    返回:'Return',
    请将二维码对准摄像头:'Please align the QR code with the camera',
    
    免审参数:'Parameters without verification',
    自动授权截止时间:'Automatic authorization expiration time',
    请选择日期:'Please select a date',
    自动授权口令:'Automatic authorization password',
    请输入口令:'Please enter the password',
    自动授权开关:'Automatic authorization switch',
    选择日期:'Select date',   
}